import styled from 'styled-components'

import { Card, Input } from 'src/components/Ant'

const WrapCard = styled(Card)`
  margin-bottom: 16px;
`

const WrapInput = styled(Input)`
  margin-bottom: 16px;
`

export { WrapCard, WrapInput }
